import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router"
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/service/login.service';
@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit {
  passwordRestore: boolean | undefined

  constructor(private router: Router, private loginService: LoginService, private route: ActivatedRoute, private translate: TranslateService) 
  {
    this.passwordRestore = loginService.chatCrmUser.passwordRestore
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }


  ngOnInit(): void {
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }
  redirectToHome():void{
    
    if(this.passwordRestore === false){
      this.router.navigate(['/dashboard'])
    }else{
      this.router.navigate(['account'])
    }

  }
  redirectToChat():void{
    this.router.navigate(['/chat'], { queryParamsHandling: 'merge' })
  }
  redirectToDevices():void{
    this.router.navigate(['/devices'], { queryParamsHandling: 'merge' })
  }
  redirectToAccoount():void{
    this.router.navigate(['/account'], { queryParamsHandling: 'merge' })
  }
  redirectToUser():void{
    this.router.navigate(['/users'], { queryParamsHandling: 'merge' })
  }
  redirectToSettings():void{
    this.router.navigate(['/settings'], { queryParamsHandling: 'merge' })
  }
  redirectToCampaigns():void{
    this.router.navigate(['/campaigns'], { queryParamsHandling: 'merge' })
  }
}
